import { minutesToHHMM, parseHHMM } from '../lib/time';
import type { WorkRule } from './types';

/**
 * Сетка часов в виде семи строк: выключенный день — это снятый переключатель,
 * а не отсутствующая строка. Общий код для кабинета специалиста и для админа,
 * который смотрит и правит чужое расписание.
 */
export type HourRow = { weekday: number; on: boolean; from: string; to: string };

const DEFAULT_FROM = '10:00';
const DEFAULT_TO = '18:00';

export function toRows(rules: WorkRule[]): HourRow[] {
  return Array.from({ length: 7 }, (_, weekday) => {
    const r = rules.find((x) => x.weekday === weekday);
    return {
      weekday,
      on: !!r,
      from: r ? minutesToHHMM(r.start_min) : DEFAULT_FROM,
      to: r ? minutesToHHMM(r.end_min) : DEFAULT_TO,
    };
  });
}

/** Строки с мусором во времени и перевёрнутым интервалом на сервер не уходят. */
export function toRules(rows: HourRow[]): WorkRule[] {
  return rows
    .filter((r) => r.on && /^\d{1,2}:\d{2}$/.test(r.from) && /^\d{1,2}:\d{2}$/.test(r.to))
    .map((r) => ({ weekday: r.weekday, start_min: parseHHMM(r.from), end_min: parseHHMM(r.to) }))
    .filter((r) => r.end_min > r.start_min);
}
